<template>
  <div class="teaching-evaluate-statistics-detail-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="detailInfo">
      <div class="header">
        <el-form size="mini"
                 label-width="72px"
                 label-suffix="：">
          <el-row type="flex"
                  :gutter="15">
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item label="学期">{{detailInfo.semester}}</el-form-item>
            </el-col>
            <el-col  :md="8" :sm="12" :xs="24">
              <el-form-item label="教学点">{{detailInfo.site}}</el-form-item>
            </el-col>
            <el-col  :md="8" :sm="12" :xs="24">
              <el-form-item label="班级">{{detailInfo.clazz}}</el-form-item>
            </el-col>
            <el-col  :md="8" :sm="12" :xs="24">
              <el-form-item label="课程">{{detailInfo.course}}</el-form-item>
            </el-col>
            <el-col  :md="8" :sm="12" :xs="24">
              <el-form-item label="授课教师">{{detailInfo.lessonTeachers}}</el-form-item>
            </el-col>
            <el-col  :md="8" :sm="12" :xs="24">
              <el-form-item label="评教人数">{{detailInfo.evaluateCount}}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="main">
        <div class="main-cont">
          <DataGrid size="mini"
                    height="auto"
                    show-footer
                    :data="groupDetails"
                    :span-method="mergeQuotaCell"
                    :row-class-name="groupRowClassName"
                    :cell-class-name="groupCellClassName"
                    :footer-method="groupStatData"
                    footer-row-class-name="group-stat-footer"
                    show-overflow="title"
                    show-header-overflow="title">
            <DataGridColumn title="评教指标"
                            width="200px"
                            align="center"
                            fixed="left">
              <template #default="{row}">
                <span>{{row.groupName || '--'}}</span>
              </template>
            </DataGridColumn>
            <DataGridColumn title="评教项内容"
                            field="title"
                            min-width="300px"></DataGridColumn>
            <DataGridColumn title="评教人数"
                            field="itemEvaluateCount"
                            width="160px"
                            align="center"></DataGridColumn>
            <DataGridColumn title="评教总分"
                            field="itemTotalScore"
                            width="160px"
                            align="center"></DataGridColumn>
            <DataGridColumn title="评教平均分"
                            field="itemAvgScore"
                            width="160px"
                            align="center"></DataGridColumn>
          </DataGrid>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>评教详情数据加载失败</div>
        <el-button type="text"
                   @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'TeachingEvaluateStatisticsDetailMain',
  components: {
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    semester: {
      type: String,
      required: true
    },
    scheduleId: {
      type: String,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      detailInfo: null
    }
  },
  computed: {
    groupDetails () {
      let detailInfo = this.detailInfo
      if (detailInfo) {
        let details = detailInfo.details || []
        let groupDetails = []
        details.forEach(detail => {
          let items = detail.items || []
          if (items.length) {
            items.forEach((item, itemIndex) => {
              let groupDetail = {
                groupSize: itemIndex === 0 ? items.length : 0,
                groupName: detail.quota,
                ...item
              }
              groupDetails.push(groupDetail)
            })
            let getTotalScore = items.reduce((p, v) => {
              return p + v.itemTotalScore || 0
            }, 0)
            let getAvgScore = items.reduce((p, v) => {
              return p + v.itemAvgScore || 0
            }, 0) / items.length
            groupDetails.push({
              groupStat: true,
              groupName: '单个指标合计',
              itemTotalScore: getTotalScore,
              itemAvgScore: Math.round(getAvgScore * 100) / 100
            })
          }
        })
        return groupDetails
      }
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/query/detailInfo',
        method: 'post',
        data: this.$qs.stringify({
          semester: this.semester,
          postId: this.scheduleId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.detailInfo = response.data['detailInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    mergeQuotaCell ({row, column, $columnIndex}) {
      if ($columnIndex === 0 && !row.groupStat) {
        return {
          rowspan: row.groupSize,
          colspan: 1
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        }
      }
    },
    groupRowClassName ({row}) {
      if (row.groupStat) {
        return 'group-stat-row'
      }
    },
    groupCellClassName ({row, column, $columnIndex}) {
      if ($columnIndex === 0 && !row.groupStat) {
        return 'quota-merge-cell'
      }
    },
    groupStatData ({columns, data}) {
      let detailInfo = this.detailInfo
      if (detailInfo) {
        return [[
          '评教总计',
          (data || []).reduce((pd, vd) => {
            return pd + (vd.groupStat ? 0 : 1)
          }, 0),
          detailInfo.evaluateCount || 0,
          detailInfo.totalScore || 0,
          detailInfo.avgScore || 0
        ]]
      } else {
        return []
      }
    }
  },
  mounted () {
    this.loadDetailInfo()
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.loadDetailInfo()
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-statistics-detail-main {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 15px;
    box-sizing: border-box;
    & > .header {
      flex: none;
      .el-row--flex {
        flex-wrap: wrap;
        align-items: stretch;
      }
      .el-form {
        .el-form-item {
          margin-bottom: 0;
          .el-form-item__label {
            color: #909399;
            font-size: 12px;
            white-space: nowrap;
          }
          .el-form-item__content {
            color: #303133;
            font-size: 12px;
          }
        }
      }
    }
    & > .main {
      margin-top: 15px;
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .vxe-table {
          .vxe-table--header-wrapper {
            .vxe-table--header {
              .vxe-header--row {
                background-color: #f9f9fa;
              }
            }
          }
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                &.group-stat-row {
                  color: #303133;
                  font-weight: bold;
                  background-color: #f9f9fa;
                }
                .vxe-body--column {
                  &.quota-merge-cell {
                    position: relative;
                    background-color: #fff;
                    &:after {
                      content: '';
                      position: absolute;
                      right: 0;
                      top: 0;
                      bottom: 0;
                      width: 1px;
                      background-color: #ebeef5;
                    }
                  }
                }
              }
            }
          }
          .vxe-table--footer-wrapper {
            .vxe-table--footer {
              .vxe-footer--row {
                &.group-stat-footer {
                  color: #303133;
                  font-weight: bold;
                  background-color: #f9f9fa;
                }
              }
            }
          }
          .vxe-table--fixed-left-wrapper {
            box-shadow: none;
            &.scrolling--middle {
              border-right: 1px solid rgba(0,0,0,.05);
            }
          }
        }
      }
    }
  }
</style>
